import { Link } from 'react-router-dom';
import { MarketplaceArche } from '../../lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface ArcheCardProps {
  arche: MarketplaceArche;
}

export function ArcheCard({ arche }: ArcheCardProps) {
  const pricingLabel =
    arche.pricing.model === 'free'
      ? 'Free'
      : arche.pricing.model === 'fixed' && arche.pricing.priceCents
        ? `$${(arche.pricing.priceCents / 100).toFixed(2)}`
        : 'Variable';

  return (
    <Link to={`/marketplace/arches/${arche.archId}`} className="block h-full">
      <Card className="h-full overflow-hidden hover:shadow-lg transition-shadow flex flex-col">
        {arche.imageRef ? (
          <div className="aspect-video bg-muted flex-shrink-0">
            <img src={arche.imageRef} alt={arche.name} className="w-full h-full object-cover" />
          </div>
        ) : (
          <div className="aspect-video bg-linear-to-br from-primary/80 to-primary flex items-center justify-center p-4 flex-shrink-0">
            <h3 className="text-lg text-primary-foreground font-semibold text-center line-clamp-3">
              {arche.name}
            </h3>
          </div>
        )}

        <CardContent className="p-4 flex flex-col flex-1">
          <p className="text-sm text-muted-foreground line-clamp-3 mb-3 min-h-[3.75rem]">
            {arche.simpleDescription}
          </p>

          <div className="flex items-center justify-between text-xs text-muted-foreground mb-2 mt-auto">
            {arche.categoryName && <Badge variant="outline">{arche.categoryName}</Badge>}
            <div className="flex items-center gap-3">
              <span title="Fias Fitness Score">FFS: {(arche.fitnessScore * 100).toFixed(0)}%</span>
              <span title="Times Used">{arche.invocationCount.toLocaleString()} runs</span>
            </div>
          </div>

          <div className="flex justify-end">
            <Badge variant={arche.pricing.model === 'free' ? 'secondary' : 'default'}>
              {pricingLabel}
            </Badge>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
